
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dispatchCloneProject,
  dispatchGetProjectDetail,
  dispatchGetProjects,
  dispatchResetProject,
} from "@/store/project/actions";
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import { readUserProfile } from "@/store/main/getters";
import { ElMessage } from "element-plus";
import { dispatchCreateDeviceSpecsList } from "@/store/device/actions";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class ReportList extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public imageUrl = "";
  public loading = false;
  public edit = true;
  public registerForm = {
    model: "",
    type: "",
    rank: "",
    score: "",
    user_rank: "",
    user_percentage: "",
    name: "",
    oem: "",
    cpu_name: "",
    cpu_model: "",
    core_num: "",
    ram: "",
    gpu_name: "",
    resolution: "",
  };
  public copyForm = {
    project: "",
    all: false,
    account: false,
    device: false,
    scene: false,
    pipeline: false,
    project_user: false,
    task: false,
    performance_brief: false,
    report: false,
  };
  public async mounted() {
    dispatchGetProjects(store, { project: this.localProject });
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await this.getImage;
    this.projects;
  }
  public get myProjects() {
    return readProjectDetail(store);
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 获取图片路径
  public handleAvatarSuccess(res: any, file: any) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }

  public formData: any = new FormData();

  public async ploadImage(param: any) {
    this.loading = true;
    this.formData.append("file", param.file);
    this.getImage;
    this.loading = false;
  }
  // 获取当前图片的路径
  public get getImage() {
    const project_img = this.myProjects.icon;
    return project_img;
  }
  // 编辑
  public async editOption(type: string) {
    switch (type) {
      case "edit":
        this.edit = false;
        break;
      case "ok":
        this.edit = true;
        this.formData.append("project", this.localProject);
        this.formData.append("project_name", this.myProjects.project_name);
        this.formData.append("pkg_name", this.myProjects.pkg_name);
        this.formData.append("ios_pkg_name", this.myProjects.ios_pkg_name);
        await dispatchResetProject(store, this.formData);
        await dispatchGetProjectDetail(store, {
          id: this.localProject,
          project: this.localProject,
        });
        await this.getImage;
        location.reload();
        break;
      case "no":
        this.edit = true;
        await dispatchGetProjectDetail(store, {
          id: this.localProject,
          project: this.localProject,
        });
        break;
    }
  }
  public imgPreview(file: any, fileList: any) {
    let fileName = file.name;
    let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
    if (regex.test(fileName.toLowerCase())) {
      this.myProjects.icon = URL.createObjectURL(file.raw);
    } else {
      ElMessage({
        message: "请选择图片...",
        showClose: true,
      });
    }
  }

  // 复制数据, 勾选全部
  public all() {
    if (this.copyForm.all) {
      (this.copyForm.account = true),
        (this.copyForm.device = true),
        (this.copyForm.scene = true),
        (this.copyForm.pipeline = true),
        (this.copyForm.project_user = true),
        (this.copyForm.task = true),
        (this.copyForm.performance_brief = true),
        (this.copyForm.report = true);
    }
  }
  public cacel_all(param: string) {
    if (!this.copyForm[param]) {
      this.copyForm.all = false;
    }
  }

  // 注册设备
  public async RegisterForm() {
    let RegisterForm = {
      model: this.registerForm.model,
      type: Number(this.registerForm.type),
      rank: Number(this.registerForm.rank),
      score: Number(this.registerForm.score),
      user_rank: Number(this.registerForm.user_rank),
      user_percentage: this.registerForm.user_percentage,
      name: this.registerForm.name,
      oem: this.registerForm.oem,
      cpu_name: this.registerForm.cpu_name,
      cpu_model: this.registerForm.cpu_model,
      core_num: Number(this.registerForm.core_num),
      ram: Number(this.registerForm.ram),
      gpu_name: this.registerForm.gpu_name,
      resolution: this.registerForm.resolution,
      project: this.localProject,
    };
    await dispatchCreateDeviceSpecsList(store, RegisterForm);
    ElMessage({
      message: "设备注册成功",
      type: "success",
    });
    this.registerForm = {
      model: "",
      type: "",
      rank: "",
      score: "",
      user_rank: "",
      user_percentage: "",
      name: "",
      oem: "",
      cpu_name: "",
      cpu_model: "",
      core_num: "",
      ram: "",
      gpu_name: "",
      resolution: "",
    };
  }
  // 注册设备
  public async copyFunc() {
    let clone_list: string[] = [];
    if (this.copyForm.account) {
      clone_list.push("account");
    }
    if (this.copyForm.device) {
      clone_list.push("device");
    }
    if (this.copyForm.scene) {
      clone_list.push("scene");
    }
    if (this.copyForm.pipeline) {
      clone_list.push("pipeline");
    }
    if (this.copyForm.project_user) {
      clone_list.push("project_user");
    }
    if (this.copyForm.task) {
      clone_list.push("task");
    }
    if (this.copyForm.performance_brief) {
      clone_list.push("performance_brief");
    }
    if (this.copyForm.report) {
      clone_list.push("report");
    }
    let copyParams = {
      old_project: Number(this.copyForm.project),
      new_project: this.localProject,
      clone_list: clone_list,
    };
    dispatchCloneProject(store, copyParams);
    (this.copyForm.project = ""),
      (this.copyForm.all = false),
      (this.copyForm.account = false),
      (this.copyForm.device = false),
      (this.copyForm.scene = false),
      (this.copyForm.pipeline = false),
      (this.copyForm.project_user = false),
      (this.copyForm.task = false),
      (this.copyForm.performance_brief = false),
      (this.copyForm.report = false);
  }

  public get projects() {
    const project_list = (readAdminProjects(store) as any[]).map((item) => {
      return { id: item.id, name: item.project_name };
    });
    return project_list;
  }

  // 重置
  public async ResetBtn() {
    this.registerForm = {
      model: "",
      type: "",
      rank: "",
      score: "",
      user_rank: "",
      user_percentage: "",
      name: "",
      oem: "",
      cpu_name: "",
      cpu_model: "",
      core_num: "",
      ram: "",
      gpu_name: "",
      resolution: "",
    };
  }
}
